import { string } from "prop-types";
import React from "react";

export const PlusIcon = ({ color = "#F65932" }) => {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="6" width="3" height="15" fill={color} />
			<rect x="15" y="6" width="3" height="15" transform="rotate(90 15 6)" fill={color} />
		</svg>
	);
};

PlusIcon.propTypes = {
	color: string,
};
